<template>
  <div
    class="modal fade"
    id="surveyElementSecurityModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.SE1000 }}</b>
          </h4>
          <label class="control-label">{{ surveyElement.name }}: {{ surveyElement.title }}</label>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <ul class="nav nav-tabs nav-security" style="margin-bottom: 15px">
              <li class="active">
                <a href="#editorSecurityVisibility" data-toggle="tab">{{ lang.SE1019 }}</a>
              </li>
              <li>
                <a href="#editorSecurityReporting" data-toggle="tab">{{ lang.SE1020 }}</a>
              </li>
            </ul>
            <div id="editorSecurityTabContent" class="tab-content">
              <div
                class="tab-pane fade active in"
                id="editorSecurityVisibility"
              >
                <div class="table-security-settings">
                  <table
                    class="table table-hover"
                    style="margin: 0px"
                    v-if="securitySettings.Rules && Object.keys(securityElements).length > 0"
                  >
                    <thead>
                      <tr>
                        <th class="col-md-1">{{ lang.SE1036 }}</th>
                        <th class="col-md-2">{{ lang.SE1021 }}</th>
                        <th class="col-md-7">{{ lang.SE1022 }}</th>
                        <th class="col-md-1 text-center">{{ lang.SE1024 }}</th>
                        <th class="col-md-1"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="rule in securitySettings.Rules"
                        :key="rule.RuleNumber"
                      >
                        <td class="col-md-1 text-left">
                          <span class="rolenumber">{{ rule.RuleNumber }}</span>
                        </td>
                        <td class="col-md-2">
                          <div class="form-group">
                            <!-- select security level -->
                            <select2
                              class="form-control"
                              v-model="rule.RuleType"
                              @change="ruleTypeChanged(rule)"
                              :key="`securityLevelSelect${rule.RuleNumber}`"
                            >
                              <option :value="undefined"></option>
                              <option
                                v-for="(text, key) in securitySettingsStrings"
                                :key="key"
                                :value="key"
                              >
                                {{ text }}
                              </option>
                            </select2>
                          </div>
                        </td>
                        <td class="col-md-7">
                          <div
                            v-show="rule.RuleType === 'LocationProperty'"
                            class="form-group nopadding col-12"
                          >
                            <!-- select LocationProperty -->
                            <select2
                              :id="`locationPropertySelect${rule.RuleNumber}`"
                              class="form-control"
                              width="100%"
                              :ref="`locationPropertySelect${rule.RuleNumber}`"
                              v-model="rule[rule.RuleType ]"
                              :disabled="!rule.RuleType"
                              :multiple="false"
                              :placeholder="lang.SE1037"
                              @change="(d) => { ruleValueChanged(rule, d);}"
                              :key="`locationPropertySelect${rule.RuleNumber}`"
                            >
                              <option
                                v-for="element in getElementsForCurrentRuleType(rule.RuleType)"
                                :key="element[getIdKeyOfRuleType(rule.RuleType)]"
                                :value="element[getIdKeyOfRuleType(rule.RuleType)]"
                              >
                                {{ getElementName(element) }}
                              </option>
                            </select2>
                            <div id="foo">
                              <!-- select LocationProperty Value -->
                              <select2
                                :id="`locationPropertyValueSelect${rule.RuleNumber}`"
                                class="form-control"
                                width="100%"
                                :ref="`locationPropertyValueSelect${rule.RuleNumber}`"
                                v-model="rule['LocationPropertyValue']"
                                :key="`locationPropertyValueSelect${rule.RuleNumber}`"
                                :multiple="true"
                                :placeholder="lang.SE1037"
                                :disabled="!rule[rule.RuleType]"
                              >
                                <option
                                  v-for="(value, idx) in getLocationPropertyValues(rule[rule.RuleType])"
                                  :key="idx"
                                  :value="value.LocationPropertyValue"
                                >
                                  {{ value.LocationPropertyValue }}
                                </option>
                              </select2>
                            </div>
                          </div>
                          <div
                            v-show="rule.RuleType != 'LocationProperty'"
                            class="form-group nopadding col-12"
                          >
                            <!-- select element -->
                            <select2
                              width="100%"
                              class="form-control"
                              :ref="`securityRuleElementSelect${rule.RuleNumber}`"
                              :id="`securityRuleElementSelect${rule.RuleNumber}`"
                              v-model="rule[rule.RuleType]"
                              :key="`securityRuleElementSelect${rule.RuleNumber}`"
                              :disabled="!rule.RuleType"
                              :multiple="true"
                              :allowClear="true"
                              :placeholder="lang.SE1037"
                              :minimumInputLength="getElementsForCurrentRuleType(rule.RuleType).length > 500 ? 2 : 0"
                              @change="
                                (d) => {
                                  if (rule.RuleType == 'LocationProperty') rule[rule.RuleType] = d;
                                  ruleValueChanged(rule);
                                }"
                              :tags="false"
                            >
                              <option
                                v-for="element in getElementsForCurrentRuleType(rule.RuleType)"
                                :key="element[getIdKeyOfRuleType(rule.RuleType)]"
                                :value="element[getIdKeyOfRuleType(rule.RuleType)]"
                              >
                                {{ getElementName(element) }}
                              </option>
                            </select2>
                          </div>
                        </td>
                        <td class="col-md-1">
                          <div class="checkbox" v-if="rule.RuleType === 'Wave'">
                            <label>
                              <input type="checkbox" v-model="rule.WaveFF" />
                              <span class="checkbox-material">
                                <span class="check"></span>
                              </span>
                            </label>
                          </div>
                        </td>
                        <td class="col-md-1">
                          <button
                            type="button"
                            class="btn"
                            @click="removeGeneralSetting(rule.RuleNumber)"
                          >
                            <i class="material-icons md-24" style="color: red">clear</i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row nopadding">
                  <button
                    type="button"
                    class="btn btn-raised dialog-btn-primary"
                    @click="addNewGeneralSetting()"
                  >
                    {{ lang.SE1025 }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-raised btn-danger"
                    @click="clearGeneralSettings()"
                  >
                    {{ lang.SE1026 }}
                  </button>
                </div>

                <div class="row nopadding">
                  <div class="col-12">
                    <div>
                      <textarea
                        rows="4"
                        id="textareaSecuritySettingsExpression"
                        class="form-control"
                        v-model="securitySettings.Expression"
                        :placeholder="`${lang.SE1038}, ${lang.SE1039}: (1 and 2) or not 3`"
                        @keydown.tab.prevent="globals.insertAtCaret('textareaSecuritySettingsExpression','\t')"
                      ></textarea>
                      <p
                        id="validationMessage"
                        :class="{'validation-error': validationMessage.Error,}"
                        style="text-align: left"
                      >
                        {{ validationMessage.Msg }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade" id="editorSecurityReporting">
                <div v-if="Object.keys(securityGroups).length < 1">
                  {{ lang.SE1031 }}
                </div>

                <div v-else>
                  <div class="form-group">
                    <label
                      for="selectSecurityTargetGroup"
                      class="col-md-2 control-label"
                      >{{ lang.SE1030 }}</label
                    >
                    <div class="col-md-10">
                      <select
                        class="form-control"
                        id="selectSecurityTargetGroup"
                        v-model="selectedSecurityGroup"
                      >
                        <option
                          v-for="(name, guid) in securityGroups"
                          :key="guid"
                          :value="guid"
                        >
                          {{ name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="table-security-settings">
                    <table class="table table-hover" style="margin: 0px">
                      <thead>
                        <th style="width: 20%"></th>
                        <th style="width: 80%"></th>
                      </thead>
                      <tbody>
                        <template
                          v-for="(title, key) in reportingSettingsStrings"
                        >
                          <tr
                            :key="key"
                            v-if="
                              key === 'notVisibleInCheckReport' ||
                              key === 'uploadVisibleInMediaExplorer' ||
                              key === 'notVisibleInRawData'
                            "
                          >
                            <td style="padding: 4px">
                              <div class="checkbox" style="margin: 0px">
                                <label>
                                  <input
                                    type="checkbox"
                                    :id="'cb_reportingVisibility_' + key"
                                    v-model="currentReportingGroupSettings[key]"
                                  />
                                  <span class="checkbox-material">
                                    <span class="check"></span>
                                  </span>
                                </label>
                              </div>
                            </td>
                            <td style="font-size: 16px; padding: 6px">
                              <label
                                role="button"
                                :for="'cb_reportingVisibility_' + key"
                                class="text-black nopadding"
                                style="width: 100%"
                                >{{ title }}</label
                              >
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.SE1027 }}
          </button>
          <button
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="saveSecuritySettings()"
          >
            {{ lang.SE1028 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import select2 from "@/components/Tools/Select2";

export default {
  name: "SurveyElementSecurityModal",
  components: { select2 },
  props: {
    modalVisible: {
      type: Boolean,
      default: false,
    },
    surveyElement: {
      type: Object,
      required: true,
    },
    surveyData: {
      type: Object,
      required: true,
    },
    surveyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      securitySettings: {},
      reportingSettings: {},
      securityElements: {},
      securityGroups: {},
      selectedSecurityGroup: "",
      currentReportingGroupSettings: {},
      reportingSettingsStrings: {},
      securitySettingsStrings: {},
      defaultReportingSettings: {
        notVisibleInCheckReport: false,
        notVisibleInRawData: false,
        uploadVisibleInMediaExplorer: false,
      },
      validationMessage: {
        Msg: "",
        MsgNr: 0,
        Error: false,
      },
      lang: {
        SE1000: "Security Settings",
        SE1001: "Not visible in Check Report",
        SE1002: "PDF sent by Mail",
        SE1003: "External Interface",
        SE1004: "External Custom",
        SE1005: "Query Tool",
        SE1006: "Dashboard",
        SE1007: "Check Explorer",
        SE1008: "Aggregated Report",
        SE1009: "Raw Data Exports",
        SE1010: "Frequencies",
        SE1011: "Media Explorer",
        SE1012: "Upload visible in Media Explorer",
        SE1013: "Role",
        SE1014: "Security Group",
        SE1015: "Wave",
        SE1016: "Scenario",
        SE1017: "Custom Property",
        SE1018: "Location",
        SE1019: "Operative",
        SE1020: "Reporting",
        SE1021: "Security Level",
        SE1022: "Elements",
        SE1023: "Visible",
        SE1024: "FF",
        SE1025: "Add new",
        SE1026: "Remove all",
        SE1027: "Cancel",
        SE1028: "Save",
        SE1029: "Not visible in Raw Data",
        SE1030: "Group",
        SE1031: "There is no group approved for this survey.",


        SE1036: "Condition",
        SE1037: "Please select...",
        SE1038: "Expression",
        SE1039: "e.g.",
      },
    };
  },
  watch: {
    modalVisible() {
      if (this.modalVisible) this.showModal();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this, this.setListTranslations);
    },
    // surveyElement: {
    //   handler(newElement, oldElement) {
    //     if (!newElement) return;

    //     this.initializeGeneralVisibilitySettings();
    //     if (oldElement) this.initializeReportingVisibilitySettings();
    //   },
    //   immediate: true,
    // },
    selectedSecurityGroup(newValue, oldValue) {
      if (!newValue) return;

      if (oldValue) {
        this.storeReportingSettingsForGroup(oldValue);
      }
      this.readReportingSettingsForGroup(newValue);
    },
  },
  mounted() {
    if (this.modalVisible) this.showModal();

    $("#surveyElementSecurityModal").on("hide.bs.modal", (e) => {
      this.$emit("closeModal");
      this.clearErrorMsg();
    });

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this, this.setListTranslations);
    this.setListTranslations();
    this.getSecurityElements();
    this.getSecurityGroupsOfSurvey();
  },
  methods: {
    showModal() {
      this.initializeSecuritySettings();
      this.initializeReportingSettings();
      this.selectedSecurityGroup = Object.keys(this.securityGroups)[0];
      if (this.securitySettings && this.securitySettings.Rules && this.securitySettings.Rules.length < 1) this.clearGeneralSettings();
      $("#surveyElementSecurityModal").modal("show");
    },

    hideModal() {
      $("#surveyElementSecurityModal").modal("hide");
      this.validationMessage.Msg = "";
    },
    clearErrorMsg() {
      this.validationMessage.Msg = "";
      this.validationMessage.Error = false;
    },
    /**
     * remove invalid rules
     */
    cleanRules() {
      if (this.securitySettings.Rules.length > 0) {
        _.remove(this.securitySettings.Rules, (r) => {
          return (
            _.isEmpty(r) ||
            !r.RuleType ||
            !r[r.RuleType] ||
            r[r.RuleType].length < 1 ||
            (r.RuleType == "LocationProperty" && !r.LocationPropertyValue[0])
          );
        });
      }
    },
    /**
     * Request to validate the rules and expression obj
     * @param {string} expression the logic expression
     * @param {array} rules all the RulesNumbers
     * @returns { Promise } returns data.valid = true if is valid and
     * contains an error msg in data.validationMessage.Msg on error
     */
    requestValidation(expression, rules) {
      let queryString = "/api/Surveys/ValidateSecurityCondition"; // ToDo : add endpoint
      let data = JSON.stringify({
        Expression: expression,
        RuleNumbers: rules,
      });

      return $.ajax({
        url: queryString,
        type: "POST",
        data,
        success: function (data) {
          return data;
        },
        error: function (jqXHR, textStatus, errorThrown) {
          var err = [jqXHR, textStatus, errorThrown];
          return err;
        },
      });
    },

    saveSecuritySettings() {
      this.cleanRules();

      // REMOVE UNNECESSARY ELEMENTS OF RULES DEPENDING ON RULETYPE
      // REPLACES PART OF RuleTypeChanged() METHOD
      // #1781 RELATED
      for (let rule of this.securitySettings.Rules) {
        if (rule.RuleType == "Wave") {
          rule.LocationPropertyValue = [];
          delete rule.LocationProperty;
          delete rule.Location;
          delete rule.Scenario;
        } else if (rule.RuleType == "Scenario") {
          rule.LocationPropertyValue = [];
          delete rule.LocationProperty;
          delete rule.Location;
          delete rule.WaveFF;
          delete rule.Wave;
        } else if (rule.RuleType == "Location") {
          rule.LocationPropertyValue = [];
          delete rule.LocationProperty;
          delete rule.WaveFF;
          delete rule.Wave;
          delete rule.Scenario;
        } else if (rule.RuleType == "LocationProperty") {
          delete rule.Location;
          delete rule.WaveFF;
          delete rule.Wave;
          delete rule.Scenario;
        }
      }

      if (
        this.securitySettings.Rules.length == 0 &&
        this.securitySettings.Expression != ""
      ) {
        this.validationMessage.Msg = "No usable Rules";
        this.validationMessage.Error = true;
        return;
      }

      let rules = this.securitySettings.Rules.map((el) => el.RuleNumber);

      this.requestValidation(this.securitySettings.Expression, rules)
        .then((data) => {
          if (data.Valid) {
            this.validationMessage.Error = false;
            this.validationMessage.Msg = "";
            this.saveAndClose();
          } else {
            this.validationMessage.Error = true;
            this.validationMessage.Msg = data.ErrorMessage;
          }
        })
        .catch((err) => {
          console.error(err);
          this.globals.showErrorSnackbar("Failed to Validate Expression");
        });
    },
    saveAndClose() {
      this.storeReportingSettingsForGroup(this.selectedSecurityGroup);
      let settings = {
        general: this.generateSecuritySettingsStoreObject(),
        reporting: this.reportingSettings,
      };
      this.$emit("saveSecuritySettings", settings);
      this.$forceUpdate();
      this.hideModal();
    },
    generateSecuritySettingsStoreObject() {
      let result = _.cloneDeep(this.securitySettings);
      if (result.Rules.length > 0) {
        for (let rule of result.Rules) {
          let newRuleEntry = {};

          if (rule.RuleType == "LocationProperty") {
            if (Array.isArray(rule.LocationProperty)) {
              newRuleEntry.LocationPropertyGuid = rule.LocationProperty[0];
            } else {
              newRuleEntry.LocationPropertyGuid = rule.LocationProperty;
            }
            newRuleEntry.LocationPropertyValues = _.map(
              rule.LocationPropertyValue,
              (val) => {
                return { LocationPropertyValue: val };
              }
            );
            delete rule.LocationPropertyValue;
          } else {
            newRuleEntry[`${rule.RuleType}s`] = _.map(
              rule[rule.RuleType],
              (guid) => {
                return { [this.getIdKeyOfRuleType(rule.RuleType)]: guid };
              }
            );
          }

          if (rule.RuleType == "Wave") {
            // undefined, false, NULL etc.
            if(!rule.WaveFF) {
              newRuleEntry.WaveFF = false;
            }
            else  {
              newRuleEntry.WaveFF = rule.WaveFF;
            }
            // cleanup for save request (otherwise it is inside Rules and inside Wave Array (has to be in Wave Array))
            delete rule.WaveFF;
          }

          rule[rule.RuleType] = newRuleEntry;
        }
      } else {
        delete result.Rules;
        delete result.Expression;
      }
      return result;
    },

    setListTranslations() {
      this.reportingSettingsStrings = {
        notVisibleInCheckReport: this.lang.SE1001,
        notVisibleInRawData: this.lang.SE1029,
        pdfSentByMail: this.lang.SE1002,
        externalInterface: this.lang.SE1003,
        externalCustom: this.lang.SE1004,
        queryTool: this.lang.SE1005,
        dashboard: this.lang.SE1006,
        checkExplorer: this.lang.SE1007,
        aggregatedReport: this.lang.SE1008,
        rawDataExports: this.lang.SE1009,
        frequencies: this.lang.SE1010,
        mediaExplorer: this.lang.SE1011,
        uploadVisibleInMediaExplorer: this.lang.SE1012,
      };
      this.securitySettingsStrings = {
        Role: this.lang.SE1013,
        // securityGroup: this.lang.SE1014,
        Wave: this.lang.SE1015,
        Scenario: this.lang.SE1016,
        LocationProperty: this.lang.SE1017,
        Location: this.lang.SE1018,
      };
    },

    clearGeneralSettings() {
      this.securitySettings.ElementGuid = this.surveyElement.guid.toUpperCase();
      this.securitySettings.Expression = "";
      this.securitySettings.Rules = [];
      this.$forceUpdate();
    },

    addNewGeneralSetting() {
      let newSetting = {
        RuleNumber: this.generateNewRuleNumber(),
      };
      this.securitySettings.Rules.push(newSetting);

      this.$forceUpdate();
    },

    removeGeneralSetting(ruleNumber) {
      _.remove(this.securitySettings.Rules, (r) => r.RuleNumber == ruleNumber);
      //TODO: Remove rule from expression
      this.$forceUpdate();
    },

    generateNewRuleNumber() {
      if (!this.securitySettings.Rules || !this.securitySettings.Rules[0])
        return 1;
      let maxNumber = 1;
      for (let rule of this.securitySettings.Rules) {
        if (rule.RuleNumber > maxNumber) maxNumber = rule.RuleNumber;
      }
      return maxNumber + 1;
    },

    ruleTypeChanged(obj) {
      if (!obj) return;

      // LETTING THIS RUN ALWAYS SHOWS WAVEFF AS FALSE - FIX IT IF YOU WANT TO USE THIS
      for (let prop in obj) {
        if (
          prop !== "RuleType" &&
          prop !== "RuleNumber" &&
          !(obj.RuleType === "Wave" && prop === "WaveFF")
        )
          delete obj[prop];
      }

      if (obj.RuleType) {
        if (obj.RuleType == "LocationProperty") obj.LocationPropertyValue = [];
      }

      this.$forceUpdate();
    },

    ruleValueChanged(rule, d) {
      if (rule.RuleType == "LocationProperty") {
        // rule.LocationPropertyValue = [];
        // this.$refs[`locationPropertySelect${rule.RuleNumber}`][0].reinit();
      }
      this.$forceUpdate();
    },

    getListNameOfRuleType(ruleType) {
      let listName = "";
      if (!ruleType) return listName;

      switch (ruleType) {
        case "Role":
          listName = "SecurityRoles";
          break;
        // case "securityGroup":
        //   listName = "SecurityGroups";
        //   break;
        case "Wave":
          listName = "Waves";
          break;
        case "Scenario":
          listName = "Scenarios";
          break;
        case "LocationProperty":
          listName = "LocationProperties";
          break;
        case "Location":
          listName = "Locations";
          break;
      }
      return listName;
    },

    getIdKeyOfRuleType(ruleType)  {
      let idKey = "";
      if (!ruleType) return idKey;

      switch (ruleType) {
        case "Role":
          idKey = "RoleId";
          break;
        // case "securityGroup":
        //   idKey = "GroupGuid";
        //   break;
        case "Wave":
          idKey = "WaveGuid";
          break;
        case "Scenario":
          idKey = "ScenarioGuid";
          break;
        case "LocationProperty":
          idKey = "LocationPropertyGuid";
          break;
        case "Location":
          idKey = "LocationGuid";
          break;
      }
      return idKey;
    },

    getElementsForCurrentRuleType(ruleType) {
      let elements = [];
      if (!ruleType) return elements;

      let listName = this.getListNameOfRuleType(ruleType);
      if (listName) elements = this.securityElements[listName];
      return elements;
    },

    getLocationPropertyValues(prop) {
      if (
        !this.securityElements ||
        _.isEmpty(this.securityElements) ||
        !this.securityElements.LocationProperties
      ) {
        return [];
      }
      let locationProp = this.securityElements.LocationProperties.find((p) => {
        if (Array.isArray(prop)) {
          return p.LocationPropertyGuid === prop[0];
        } else {
          return p.LocationPropertyGuid === prop;
        }
      });
      if (locationProp && locationProp.LocationPropertyValues)
        return locationProp.LocationPropertyValues;
    },

    getElementName(element) {
      let keys = Object.keys(element);
      for (let k of keys) {
        if (k.indexOf("Name") > -1) return element[k];
      }
      return "";
    },

    getSecurityElements() {
      let getString = `/api/data/SecurityElements?SurveyId=${this.surveyId}`;

      $.ajax({
        method: "GET",
        url: getString,
        success: (data) => {
          this.securityElements = data;
        },
        error: () => {
          console.error(
            "SecurityElements data access failed in getSecurityElements()"
          );
          this.globals.showErrorSnackbar("Security data access failed");
        },
      });
    },

    getSecurityGroupsOfSurvey() {
      let getString = `api/SecurityGroups/Data/Survey/${this.surveyData.SurveyGuid}`;

      $.ajax({
        method: "GET",
        url: getString,
        success: (data) => {
          this.securityGroups = data;
          this.selectedSecurityGroup = Object.keys(this.securityGroups)[0];
          this.initializeReportingSettings();
        },
        error: () => {
          console.error(
            "Security group data access failed in getSecurityGroupsOfSurvey()"
          );
          this.globals.showErrorSnackbar("Security group data access failed");
        },
      });
    },

    initializeSecuritySettings() {
      /**
       * @type {Array}
       */
      const SecuritySettings = this.surveyData.SecuritySettings;
      let ElsecSettings;
      if (SecuritySettings) {
        ElsecSettings = SecuritySettings.find(
          (el) => el.ElementGuid === this.surveyElement.guid.toUpperCase()
        );        
      }

      if (ElsecSettings) {
        ElsecSettings = _.cloneDeep(ElsecSettings);

        if (!ElsecSettings.Rules) {
          ElsecSettings.Rules = [];
          ElsecSettings.Expression = "";
        }
        for (let rule of ElsecSettings.Rules) {
          if (rule.RuleType == "Wave") {
            rule.WaveFF = rule.Wave.WaveFF;
          }

          if (rule.RuleType == "LocationProperty") {
            if (
              rule.LocationProperty &&
              rule.LocationProperty.LocationPropertyValues
            ) {
              rule.LocationPropertyValue =
                rule.LocationProperty.LocationPropertyValues.map(
                  (el) => el.LocationPropertyValue
                );
              rule.LocationProperty =
                rule.LocationProperty.LocationPropertyGuid;
            }
          } 
          // else if (rule.RuleType == "Role") {

          // } 
          else {
            rule[rule.RuleType] = _.map(
              rule[rule.RuleType][`${rule.RuleType}s`],
              (obj) => {
                return obj[this.getIdKeyOfRuleType(rule.RuleType)];
              }
            );
          }
        }
        this.securitySettings = ElsecSettings;

        for (let refName in this.$refs) {
          if (this.$refs[refName][0] && this.$refs[refName][0].updateValue)
            this.$refs[refName][0].updateValue();
        }
      } else {
        this.securitySettings = {
          ElementGuid: this.surveyElement.guid.toUpperCase(),
          Expression: "",
          Rules: [],
        };
      }
      this.$forceUpdate();
    },

    initializeReportingSettings() {
      if (!this.surveyData || !this.surveyData.ReportingSettings) return -1;

      const repSettings = this.surveyData.ReportingSettings.find(
        (el) => el.ElementGuid === this.surveyElement.guid.toUpperCase()
      );

      if (repSettings) {
        this.reportingSettings = _.cloneDeep(repSettings);
      } else {
        this.reportingSettings = {
          ElementGuid: this.surveyElement.guid.toUpperCase(),
          Groups: [],
        };

        this.reportingSettings.Groups.push({
          GroupGuid: this.selectedSecurityGroup,
          Settings: _.cloneDeep(this.defaultReportingSettings),
        });
      }
      this.readReportingSettingsForGroup(this.selectedSecurityGroup);
    },

    readReportingSettingsForGroup(groupGuid) {
      if (!this.reportingSettings) return -1;
      const newGroup = this.reportingSettings.Groups.find(
        (el) => el.GroupGuid === groupGuid
      );

      this.currentReportingGroupSettings =
        newGroup && newGroup.Settings
          ? newGroup.Settings
          : _.cloneDeep(this.defaultReportingSettings);
    },

    storeReportingSettingsForGroup(groupGuid) {
      let oldGroup = _.find(this.reportingSettings.Groups, [
        "GroupGuid",
        groupGuid,
      ]);
      if (!oldGroup)
        this.reportingSettings.Groups.push({
          GroupGuid: groupGuid,
          Settings: this.currentReportingGroupSettings,
        });
      else oldGroup.Settings = this.currentReportingGroupSettings;
    },
  },
};
</script>

<style scoped>
.table-security-settings {
  border: 1px solid lightgray;
  max-height: calc(100vh - 330px);
  margin-right: 0px;
  overflow: auto;
}
.table-security-settings tr > td {
  overflow: hidden;
}

/* Tabs on security modal */
.nav-security {
  background-color: var(--color-primary);
}
.nav-security > li {
  text-align: center;
  float: none;
  display: inline-block;
}
.nav-security > li.active {
  background-color: rgba(255, 255, 255, 0.1);
}

/* General visibility button styling */
#editorSecurityVisibility > .btn {
  border-radius: 2px;
  padding: 0.5em 1em;
  font-size: 1em;
  line-height: 1em;
  min-width: 6em;
  font-weight: bold;
  float: left;
}

/* General visibility table styling */
#editorSecurityVisibility tbody td {
  padding: 0px;
}
#editorSecurityVisibility tbody select {
  margin: 0px;
}
#editorSecurityVisibility tbody button {
  margin: 7px;
  padding: 0px;
}
#editorSecurityVisibility tbody .checkbox {
  margin: 6px;
}

.modal-lg {
  width: 1200px;
}
</style>



// WEBPACK FOOTER //
// SurveyElementSecurityModal.vue?1300fcc2